var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#FF2F7A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3234 27.0601V23.0185C41.3234 21.2216 39.8615 19.7597 38.0646 19.7597H33.7563V15.0762H20.4213V19.7597H16.1131C14.3162 19.7597 12.8543 21.2216 12.8543 23.0185V27.0601H11.4619V28.8913H12.8543V35.8443C12.8543 37.6412 14.3161 39.1031 16.1131 39.1031H38.0645C39.8615 39.1031 41.3233 37.6412 41.3233 35.8443V28.8913H42.7158V27.0601H41.3234ZM22.2526 16.9075H31.925V19.7597H22.2526V16.9075ZM39.4921 35.8442C39.4921 36.6314 38.8517 37.2718 38.0646 37.2718H16.1131C15.326 37.2718 14.6856 36.6314 14.6856 35.8442V28.8913H22.809L23.795 33.2098H30.3826L31.3686 28.8913H39.4921V35.8442ZM24.6874 28.8913H29.4903L28.9224 31.3785H25.2553L24.6874 28.8913ZM39.4921 27.0601H14.6856V23.0185C14.6856 22.2313 15.326 21.591 16.1132 21.591H38.0646C38.8517 21.591 39.4921 22.2313 39.4921 23.0185V27.0601Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedSuitcase);
export default __webpack_public_path__ + "static/media/redSuitcase.bcaad81d0de345921f6bec842e1458c3.svg";
export { ForwardRef as ReactComponent };